import React from 'react';

interface BrandWordmarkProps {
  className?: string;
  as?: 'span' | 'h1';
}

const BRAND_TITLE = 'holisTICK';

const BrandWordmark: React.FC<BrandWordmarkProps> = ({ className, as: Tag = 'span' }) => {
  const tickAt = BRAND_TITLE.toUpperCase().lastIndexOf('TICK');
  const marked =
    tickAt > 0 ? (
      <>
        {BRAND_TITLE.slice(0, tickAt)}
        <span className="brand-wordmark__tick">{BRAND_TITLE.slice(tickAt)}</span>
      </>
    ) : (
      BRAND_TITLE
    );

  return <Tag className={['brand-wordmark', className].filter(Boolean).join(' ')}>{marked}</Tag>;
};

export default BrandWordmark;
